<div class="row" [ngClass]="customCssClass || 'row mb-0'">
  <ng-content></ng-content>
</div>
